import { AppState } from '../../../core/Store';
import { State } from './reducer';

type Selector<T = any> = (redState: State, appState: AppState) => T;
function prepareSelector<T>(selector: Selector<T>) {
	return (state: AppState) => {
		return selector(state.ui.login, state);
	};
}

export const getData = prepareSelector((redState) => {
	return redState.data;
});

export const getValidators = prepareSelector((redState) => {
	return redState.validators;
});

export const getCanSave = prepareSelector((redState) => {
	return redState.canSave && redState.saveTimeout === 0;
});

export const getSaveTimeout = prepareSelector((redState) => {
	return redState.saveTimeout;
});

export const getStep = prepareSelector((redState) => {
	return redState.step;
});

export const getConfirmCode = prepareSelector((redState) => {
	return redState.confirmCode;
});
